export const assessmentDeliverables = [
  ['Executive summary & decisions', [
    'Recommended actions, investment ranges, key risks, and decisions for leadership.',
    'Priorities based on expected net value, feasibility, time to benefit, and prerequisites; recommendations to build, buy, pilot, defer, or stop.'
  ]],
  ['Current-state evidence', [
    'Workflow maps, baseline measures, and findings from leadership and frontline employee interviews and workflow investigation.',
    'Software and integration inventory, data readiness, security and operational findings, and differences between locations.',
    'Evidence sources, access limitations, assumptions, and areas that remain untested.'
  ]],
  ['AI & custom software opportunity registers', [
    'Separate opportunity records for AI automation and custom software, with owners, alternatives, dependencies, confidence, and priorities.',
    'AI suitability, data readiness, accuracy needs, failure impact, human review, and fallback requirements.',
    'Product requirements, user journeys, configure/buy/build options, and proposed architecture, integration, and migration considerations.'
  ]],
  ['AI workforce & capacity analysis', [
    'Estimated task-hours saved, work that must remain with employees, capacity released, and potential role consolidation or position reductions.',
    'Realization timing, human review effort, and assumptions needed to translate capacity into avoidable costs. Staffing decisions remain with the client.'
  ]],
  ['Financial business cases', [
    'Estimated implementation fees, third-party costs, ongoing operating budgets, net benefits, payback, and sensitivity to key assumptions.',
    'Efficiency, service, and growth opportunities, with shared costs and benefits counted once. Released capacity is distinguished from payroll savings, and revenue from profit.'
  ]],
  ['Phased implementation roadmap', [
    'Recommended pilot or first-release scope, team assumptions, milestones, dependencies, and acceptance gates.',
    'Proposed rollout sequence across operating locations, with integration and migration needs and decisions required before implementation.'
  ]],
  ['Operating & adoption plan', [
    'Recommended support responsibilities, AI oversight, training needs, and change-management approach.',
    'A benefits-measurement plan to track adoption, operational results, and the assumptions behind the business case.'
  ]],
  ['Supporting files & leadership readout', [
    'Editable financial model, risk register, business summary, and a leadership presentation and discussion of findings.',
    'A standalone assessment package you can use to make decisions without purchasing implementation services from Blake Technologies.'
  ]]
];

